export default "__VITE_ASSET__DPjR$ihV__"